export default __webpack_public_path__ + "static/media/genpact.079ce9f5.png";